<template lang="pug">
div.header
  .left-side
    router-link.button(to="/" aria-label="home")
      <svg aria-labelledby="woosha-logo" id="圖層_4" data-name="圖層 4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 394.07 56.52"><rect x="349.04" y="13.02" width="18.1" height="3.3"/><rect x="352.04" y="19.72" width="12.1" height="3.3"/><rect x="352.04" y="6.32" width="12.1" height="3.3"/><rect x="352.04" y="26.42" width="12.1" height="3.3"/><path d="M350.84,50.32h14.4V35.42h-14.4v14.9Zm3.3-11.6h7.8V47h-7.8Z"/><polygon points="391.24 19.72 382.04 19.72 382.04 5.62 378.74 5.62 378.74 19.72 369.44 19.72 369.44 23.02 378.74 23.02 378.74 50.52 382.04 50.52 382.04 23.02 391.24 23.02 391.24 19.72"/><path d="M301.44,17.32v-11H288v6.4a9,9,0,0,1-2.6,6.4l-1.9,2,2.4,2.3,1.9-2a12.33,12.33,0,0,0,3.5-8.7v-3h6.8v7.8a5.16,5.16,0,0,0,5.2,5.2h4.2v-3.4h-4.2A2.13,2.13,0,0,1,301.44,17.32Z"/><rect x="265.14" y="13.02" width="18.1" height="3.3"/><rect x="268.14" y="19.72" width="12.1" height="3.3"/><rect x="268.14" y="6.32" width="12.1" height="3.3"/><rect x="268.14" y="26.42" width="12.1" height="3.3"/><path d="M266.94,50.32h14.4V35.42h-14.4Zm3.3-11.6H278V47h-7.8Z"/><path d="M305,30.12a3,3,0,0,0-2.3-3.6,1.7,1.7,0,0,0-.7-.1h-15.9v3.3h15.6a24.18,24.18,0,0,1-6.1,11.2,25.67,25.67,0,0,1-5.4-7.2l-3,1.4a29.11,29.11,0,0,0,5.9,8,30,30,0,0,1-9,4.8l1,3.1a32.5,32.5,0,0,0,10.5-5.7,37.1,37.1,0,0,0,10.5,5.8l1.1-3.1a32.07,32.07,0,0,1-9.1-4.9A27.83,27.83,0,0,0,305,30.12Z"/><path d="M134.14,13.42h-3.3v5h-5.3v-5h-3.3v5h-5.3v-5h-3.3v5h-5.3v-5H105v5h-6.4v3.3H105v5.5h-6.4v3.3h7a28.62,28.62,0,0,1-3.5,4.3,30.64,30.64,0,0,1-4.9,4l1.7,2.8a14.37,14.37,0,0,0,2.5-1.8,17.5,17.5,0,0,1,3.3,2.8,28.48,28.48,0,0,1,2.3,2.6,22.16,22.16,0,0,1-8.6,2.7l.4,3.3c16.8-2.2,19.6-15,19.7-15.6l.4-2h-11.5c.7-1,1.4-2.1,2-3.1h21.4v3.1h-10.2v3.3h2.1v4.5a4.48,4.48,0,0,0,4.5,4.5h3.6v4.7h3.3v-4.7H140v-3.3h-5.9V37H140v-3.3h-5.9v-3.1H140v-3.3h-5.9v-5.6H140v-3.3h-5.9Zm-19.5,23.5a17.15,17.15,0,0,1-4.9,6.4,26.59,26.59,0,0,0-5.8-5.8l.4-.4.2-.2Zm16.2,5.6h-3.6a1.16,1.16,0,0,1-1.2-1.2v-4.4h4.8Zm-8.6-20.8v5.4h-5.3v-5.4Zm-13.9,0h5.3v5.4h-5.3Zm22.5,5.4h-5.3v-5.4h5.3Z"/><path d="M109.64,5.82l-2.9-1.6a30.52,30.52,0,0,1-4.6,6.1,26.79,26.79,0,0,1-4.9,4l1.7,2.8a29.52,29.52,0,0,0,5.5-4.4c.6-.6,1.1-1.2,1.7-1.8h34V7.62h-31.6A17.39,17.39,0,0,0,109.64,5.82Z"/><path d="M216.74,39.92a2.74,2.74,0,0,0-2-4.5h-19.5c.5-.7,1-1.5,1.4-2.2h21.3V12.72h-17.6c1-1,2-2.1,2.9-3.2h19.1V6.22h-40.6v3.3h17a19.54,19.54,0,0,1-3.8,3.2h-9.1v20.4h6.8a34.65,34.65,0,0,1-3.4,4.2,26.86,26.86,0,0,1-6.7,4.9l1.6,2.9a25.71,25.71,0,0,0,5.5-3.8,26.68,26.68,0,0,0,7.4,4.5,89,89,0,0,1-15.4,2l.2,3.3a89.46,89.46,0,0,0,20.6-3.3,89.48,89.48,0,0,0,20.5,3.3l.2-3.3a89,89,0,0,1-15.4-2A24.72,24.72,0,0,0,216.74,39.92Zm-2.2-15.8h-25.4v-2.4h25.4Zm0-8.1v2.4h-25.4V16Zm-25.3,11.4h25.4v2.4h-25.4Zm2.9,11.7.4-.4h20.7c-1.8,1.6-5.1,3.8-10.8,5.7A29.67,29.67,0,0,1,192.14,39.12Z"/><path d="M54.42,2V53.82c0,1.09.07,1-.93,1H1.63V2ZM4.2,23.38V52.16H51.8V7.28c-.21.28-.34.44-.46.62Q40.9,22.23,30.48,36.56a1.31,1.31,0,0,1-1.22.62c-5.33,0-10.65,0-16,0h-.82V23.38ZM50.6,4.51h-.8c-5.13,0-10.25,0-15.38,0a1.24,1.24,0,0,0-1.17.6C29,11,24.74,16.79,20.51,22.65a1.5,1.5,0,0,1-1.43.72c-1.34-.05-2.68,0-4,0V34.58h.75c4,0,8.08,0,12.12,0a1.36,1.36,0,0,0,1.26-.66L46.56,10.07ZM15.05,20.82c1,0,1.92,0,2.88,0a1.15,1.15,0,0,0,1.12-.56Q24.3,13,29.58,5.79c.28-.38.55-.77.88-1.23H15.05Zm-2.6,0V4.57H4.2V20.78Z"/></svg>
      //- img(src="@/assets/social-logo.png")
      //- img(src="@/assets/header-logo.svg")
  .right-side
    .header-button
      router-link.button(to="/about" aria-label="about") ABOUT
      .divider /
      router-link.button(to="/works?tag=all" aria-label="works") WORKS
      .divider /
      router-link.button(to="/contact" aria-label="contact") CONTACT
      .divider /
      router-link.button(to="/blog?tag=all" aria-label="blog") BLOG
    p WOOSHA DESIGN © 2022

</template>
<style lang="scss" scoped>
.header{
  display: flex;
  padding: 0px 40px;
  background-color: $green;
  position: fixed;
  width: 100%;
  z-index: 9998;
  height: 57px;
  a{
    text-decoration: none;
    color: #000;
    transition-duration: .5s;
    &:hover{
      color: #fff;
    }
  }
  .left-side{
    display: flex;
    width: 300px;
    height: 100%;
    border-bottom: solid 2px #000;
    margin-right: 30px;
    align-items: center;
    img{
      height: 25px;
      margin-top: 4px;
    }
    img:first-child{
      margin-right: 8px;
    }
    .header-square{
      margin-right: 10px;
    }
    svg{
      height: 20px;
      margin-top: 5px;
      path, rect, polygon{
        transition-duration: .5s;
      }
      &:hover{
        path, rect, polygon{
          fill: #fff;
        }
      }
    }
  }
  .right-side{
    border-bottom: solid 2px #000;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    .header-button{
      display: flex;
      align-items: center;
      // border: solid 3px red;
      .button{
        cursor: pointer;
        transition-duration: 0.5s;
        font-size: 18px;
      }
      .divider{
        margin: 0px 8px;
      }
    }
    p{
      margin: 0;
      padding: 0;
      font-size: 18px;
      line-height: 18px;
    }
  }
}
@media (max-width: 1024px) {
  .header{
    display: none;
  }
}
</style>
<script>
export default {
  name: 'Header',
  data () {
    return {
      list: [
        {
          // ch: '關於',
          en: 'ABOUT',
          type: false
        },
        {
          // ch: '服務',
          en: 'WORKS',
          type: false
        },
        {
          // ch: '專案',
          en: 'SERVICES',
          type: false
        },
        {
          // ch: '部落格',
          en: 'CONTACT',
          type: false
        },
        {
          // ch: '聯絡',
          en: 'BLOG',
          type: false
        }
      ]
    }
  },
  mounted () {
    // const that = this
    // this.marqueeText = document.querySelector('.marquee p')
    // const marqueeTextWidth = document.querySelector('.marquee p').offsetWidth
    // function getMarqueeWidth () {
    //   return document.querySelector('.marquee').offsetWidth
    // }
    // let marqueeWidth = getMarqueeWidth()

    // this.marqueeEffect = setInterval(marquee, 20)
    // function marquee () {
    //   marqueeWidth -= 1
    //   that.marqueeText.style.left = marqueeWidth + 'px'
    //   if (marqueeWidth < marqueeTextWidth * -1) {
    //     marqueeWidth = getMarqueeWidth()
    //   }
    // }
  },
  methods: {
    headerClick (index) {
      this.list.forEach((e) => {
        e.type = false
      })
      this.list[index].type = true
    }
  }
}
</script>
